export const OrgLOADING = "org/Loading";
export const OrgERROR = "org/Error";
export const OrgListSUCCESS = "org/ListSuccess";
export const OrgCreateSUCCESS = "org/CreateSuccess";
export const OrgSelect = "org/Select";
export const OrgMembersSUCCESS = "org/MembersSuccess";
export const OrgAllMembersSUCCESS = "org/AllMembersSuccess";
export const OrgOwnerTransferred = "org/OwnerTransferred";
export const OrgUpdateSUCCESS = "org/UpdateSuccess";
export const OrgDeleteSUCCESS = "org/DeleteSuccess";
